import { useMutation } from '@tanstack/react-query';

export default function useUpdateOrganizationCustomFields() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (param: { id: string; alias_id: string }) => {
      const response = await fetch(`/agent/api/custom_fields/${param.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ alias_id: param.alias_id }),
      });
      if (!response.ok) {
        throw new Error('Failed to update organization custom fields');
      }
      return await response.json();
    },
  });
}
